import { ICartProps } from '../../../../contexts/CartContext/CartContext.types';
import {
    CartWorkflowStepValidationResults,
    DefaultCartWorkflowStepValidationResults
} from '../../CartWorkflow.types';

const useValidateShippingMethodPage = (cart: ICartProps): CartWorkflowStepValidationResults => {
    const results = DefaultCartWorkflowStepValidationResults();

    if (cart.shippingMethod.address.addressLine1 === '') {
        results.isValid = false;
        results.messages.push('Address for shipping method must be selected.');
    }

    return results;
};

export default useValidateShippingMethodPage;
